<div class="agpr-targetingResults-cardWrapper agpr-contextMenu-parent agpr-deleteContainer-section">
    <ng-content></ng-content>

    <div class="agpr-contextMenu top right">
        <agpr-button
            [icon]="'fa-regular fa-duotone fa-trash-can'"
            (click)="removeParam.next(key)"
            class="contextMenu"
            tooltip="Remove"
            tooltipPosition="top"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
    </div>
</div>
